import { FC } from 'react';
import * as React from 'react';
import { ImageType } from './cms-image.types';
import { StyledImage } from './cms-image.styles';

export const CmsImage: FC<
    React.PropsWithChildren<
        ImageType & React.ImgHTMLAttributes<HTMLImageElement>
    >
> = (props) => {
    const {
        src,
        width,
        height,
        fit,
        focus,
        quality = 50,
        alt = '',
        pictureClassName = '',
        imgClassName = '',
        ...rest
    } = props;
    // Don't render anything if there's no image
    if (!src) return null;

    // Check if we're rendering an SVG because we don't want Contentful
    // to resize the image or serve a webp version
    if (src.endsWith('.svg')) {
        return (
            <img
                src={src}
                alt={alt}
                className={imgClassName === '' ? undefined : imgClassName}
            />
        );
    }

    // We can now safely assume we're handling a photographic image
    // so let's use Contentful's Image API to resize, reformat, and re-quality
    // See: https://www.contentful.com/developers/docs/references/images-api/
    const queryStringParamOperator = src.indexOf('?') > -1 ? '&' : '?';
    let fallbackUrl = src;

    fallbackUrl += `${queryStringParamOperator}q=${quality}`;
    fallbackUrl += width ? `&w=${width}` : '';
    fallbackUrl += height ? `&h=${height}` : '';
    fallbackUrl += fit ? `&fit=${fit}` : '';
    fallbackUrl += focus ? `&f=${focus}` : '';

    const imageUrl = fallbackUrl + '&fm=webp';

    return (
        <picture
            className={pictureClassName === '' ? undefined : pictureClassName}
        >
            <source srcSet={imageUrl} type="image/webp" />
            <StyledImage
                src={fallbackUrl}
                alt={alt}
                className={imgClassName === '' ? undefined : imgClassName}
                {...rest}
            />
        </picture>
    );
};

export default CmsImage;
